import React from "react";
import { Row, Col, Card, Divider } from "antd";
import styled from "styled-components";
import ContentBox from "../../../../components/layout/ContentBox";
import Layout, { InlineDiv } from "../../../../components/layout/Layout";
import I18n, { fromSyntax } from "../../../../i18n";
import { OH1 } from "../../../../components/text/OText";
import { VerticalGraphValue } from "../../../../components/chart/BarChart";
import { Colors, Metrics } from "../../../../theme";
import { DataVisualizeKeys } from "../../../../theme/Colors";
import { isAlive, isFunction, ArrayUtil, DateUtil } from "../../../../util";
import { BreadcrumbPath } from "../../../../components/navigation/OBreadcrumb";
import DatePickerCompare from "../../DatePickerCompare";
import QuestionMapping from "../../../../resources/stress/question_mapping";
import DataPercentList, { makePercent } from "../../../../components/list/DataPercentList";
import ReportAction from "../../../../actions/ReportAction";
import { ContainerLoading, PreloadDiv } from "../../../../components/loading/PersistGateLoading";
import Chart from "../../../../components/chart/";
import { VisualTotalInfomation } from "../../../../components/report/individual_user/TotalInformation";
import GraphCard from "../../../../components/report/GraphCard";
import { StressGraph, GenderSummaryBox } from "../../../../components/report/stress/";
import { CompareCol } from "../../CompareValuePanel";
import OrgUtil from "../../../../util/organize";
import DrawStressGraphList from "../../../../components/report/stress";
import QuestionBox from "../../../../components/report/stress/QuestionBox";

const ViewMode = {
	/**
     * Display one question with percentage and other detail.
     */
	DETAIL:"detail",
	/**
     * Display one question with percentage and other detail
     * and choice detail.
     */
	CHOICE:"choice",
};

class QuestionDetailPanel extends React.Component{
    state= {}
    texts={}

    choiceIndex = -1;
    breadcrumb_path = ["EMPTY"];
    percentChoices = [];
    compareChoices = undefined;
    details={}
    constructor(props){
    	super(props);
    	this.texts = {
    		individual_question:I18n.t("siderTap.individual_question"),
    		question_path_syntax:I18n.t("question_path_syntax"),
    		question_label_syntax:I18n.t("question_label_syntax"),
    		choice_path_syntax:I18n.t("choice_path_syntax"),
    		user:I18n.t("user"),
    		total_user:I18n.t("total_user"),
    		males:I18n.t("male"),
    		females:I18n.t("female"),
    		department:I18n.t("department"),
    		age_range:I18n.t("age_range")
    	};
    	this.state = {
    		viewMode: ViewMode.DETAIL,
    		isLoading: false,
    	};
    	this.initChoice(props);
    	const { setRef } = props;
    	if(isFunction(setRef)){
    		setRef(this);
    	}
    }
    componentDidMount(){
    	this.onChoiceClick(0,0, false);
    }
    componentWillReceiveProps(props){
    	const { setRef } = props;
    	if(isFunction(setRef)){
    		setRef(this);
    	}
    	this.initChoice(props);
    	this.forceUpdate();
    }
    initChoice(props){
    	const { question, compareQuestion, colorType } = props;
    	this.percentChoices = this.makePercentChoice(question.choices);
    	if(compareQuestion!==undefined){
    		this.compareChoices = this.makePercentChoice(compareQuestion.choices);
    	}
    }
    makePercentChoice(choices){
    	return makePercent(choices,"value", (val,index)=>(
    		{...val, text: fromSyntax(this.texts.choice_path_syntax.toLowerCase(), {index:index+1})}
    	));
    }
    fetchChoiceDetailOfDate(dateRange){
    	this.fetchChoiceDetail(dateRange);
    }
    fetchChoiceDetail(inputDateRange = undefined, errorOnInfo = true){
    	const { questionIndex, dateRange, onFetched, previousSummary } = this.props;
    	this.setState({isLoading:true});
    	const params = {
    		dateRange: ArrayUtil.isAliveArray(inputDateRange) ? inputDateRange : dateRange,
    		questionIndex: questionIndex,
    	};
    	if(this.choiceIndex!==-1){
    		params.choiceIndex = this.choiceIndex;
    		params.errorOnInfo = errorOnInfo;
    	}
    	ReportAction.fetchStressChoice(params).then(({summary})=>{
    		this.details = summary;
    		if(isFunction(onFetched)){
    			onFetched(summary);
    		}
    		this.setState({viewMode:ViewMode.CHOICE, isLoading:false});
    	}).catch(error=>{
    		console.error("fetchChoiceDetail.error: ", error);
    		this.setState({isLoading:false});
    	});
    }
    setBreadcrumbAt(questionIndex, choiceIndex = -1){
    	const path = [
    		{text: this.texts.individual_question, onClick:this.openQuestionList},
    		{text: fromSyntax(this.texts.question_path_syntax, {index:questionIndex+1, user:this.texts.user})}
    	];
    	if(choiceIndex!==-1){
    		path.push({text:fromSyntax(this.texts.choice_path_syntax,{index:choiceIndex+1})});
    	}
    	this.breadcrumb_path = path;
    }
    setChoiceIndex(index = 0){
    	const { questionIndex = 0 } = this.props;
    	const isChange = this.choiceIndex !== index;
    	this.choiceIndex = index;
    	this.setBreadcrumbAt(questionIndex, index);
    	return isChange;
    }
    onChoiceClick = (questionIndex, choiceIndex, errorOnInfo = true)=>{
    	const isChange = this.setChoiceIndex(choiceIndex);
    	this.setState({isLoading:isChange},()=>{
    		if(isChange){
    			this.fetchChoiceDetail(undefined, errorOnInfo);
    		}
    	});
    }
    render(){
    	const { question, questionIndex, isVertical, colorType, previousSummary } = this.props;
    	const { viewMode, isLoading } = this.state;
    	const colProps = isVertical ? { span:24 } : {sm:24, md:11};
    	return (
    		<ContainerLoading isLoading={isLoading && viewMode === ViewMode.CHOICE} >
    			<Card>
    				<QuestionBox 
    					colProps={colProps}
    					question={question}
    					questionIndex={questionIndex}
    					selectChoiceIndex={this.choiceIndex !== -1 ? this.choiceIndex : -1}
    					onChoiceClick={this.onChoiceClick}
    					colorType={colorType}
    					percentChoices={this.percentChoices}
    					compareChoices={this.compareChoices}
    					isVertical={isVertical}
    				/>
    			</Card>
    			{ viewMode === ViewMode.CHOICE ? 
    				<ContainerLoading isLoading={isLoading} 
    					style={{paddingTop:Metrics.button.bigSpaceMargin}}
    					loadingChildren={<PreloadDiv />}>
    					<BreadcrumbPath path={this.breadcrumb_path}/>
    					<DrawStressGraphList 
    						beforeCol={<GenderSummaryBox 
    							data={this.details.gender} 
    							visualColorKey={colorType} 
    						/>}
    						summary={this.details}
    						previousSummary={previousSummary}
    						colorType={colorType}
    						isVertical={isVertical}
    						single={isVertical}
    					/>
    				</ContainerLoading>
    				: undefined } 
    		</ContainerLoading>
    	);
    }
}
QuestionDetailPanel.defaultProps = {
	setRef:(ref)=>{},
	questionIndex:0,
	question:{},
	previousQuestionFetch:undefined,
	dateRange:[],
	onFetched:undefined,
	// Render all object in vertical alignment
	isVertical: false,
	colorType: DataVisualizeKeys.Primary
};
export default QuestionDetailPanel;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Stress/Panels/QuestionDetailPanel.js